module.exports = __webpack_public_path__ + "static/media/picto-admiration.db2b0f6e.svg";